import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import Global from '../store/global-selectors';
import * as Actions from '../store/shipments/filtering/shipments.filtering.actions';
import { SaveFilterViewModal } from '../components/modals/save-filterview-modal';
import { useSelectedShippingViewId } from '../pages/shipping-page/shipping-left-nav/shipping-left-nav-context';
import { useModalContext } from 'ui-components/components/modal/context';

const savedFilterViewsSelector = createSelector(
  (savedFilterViews) => savedFilterViews,
  (_, viewId) => viewId,
  (savedFilterViews, viewId) => {
    return savedFilterViews.filter((view) => view.gridViewId === viewId);
  },
);

export const SaveShippingFilterviewModalContainer = React.memo(() => {
  const { onClose } = useModalContext();
  const dispatch = useDispatch();
  const savedFilterViews = useSelector(Global.selectShipmentsFilteringSavedFilterViews);
  const currentGridViewId = useSelectedShippingViewId();
  const customFilterView = useSelector(Global.selectShipmentsFilteringCustomFilterView);

  const realSavedFilterViews = savedFilterViewsSelector(savedFilterViews, currentGridViewId);

  const saveNewFilterViewRequest = useCallback(
    (newFilterView) => {
      dispatch(Actions.saveNewFilterViewRequest(newFilterView));
      onClose();
    },
    [dispatch, onClose],
  );
  const saveExistingFilterViewRequest = useCallback(
    (viewWithNewFilters) => {
      dispatch(Actions.saveExistingFilterViewRequest(viewWithNewFilters));
      onClose();
    },
    [dispatch, onClose],
  );

  return (
    <SaveFilterViewModal
      currentGridViewId={currentGridViewId}
      customFilterView={customFilterView}
      savedFilterViews={realSavedFilterViews}
      saveExistingFilterViewRequest={saveExistingFilterViewRequest}
      saveNewFilterViewRequest={saveNewFilterViewRequest}
    />
  );
});
